// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_MJI","cls2":"Accordion-cls2_bHa Accordion-cls1_MJI"};